import MobileServiceClient from "@mocobaas/client-js/build/MobileServiceClient";
import { ProviderBase } from "./ProviderBase";
import { CreateParams, CreateResult, GetListParams, GetListResult, GetOneParams, GetOneResult, UpdateParams, DeleteParams, UpdateResult, DeleteResult } from "react-admin";
import { buildArgs } from "./utils";
import gql from "graphql-tag";
import { graphqlFetch } from "./smartfrenVirtualMsisdn";

const uriTest = "develop.m21-console.pages.dev";
const uriDev = "localhost:3000";
export class ServicesRewardProviderClass extends ProviderBase<any> {
    client: MobileServiceClient;

    constructor(client: MobileServiceClient) {
        super();
        this.client = client;
    }

    async getList(resource: string, params: GetListParams): Promise<GetListResult<any>> {
        const where: Record<string, any> = {};
        const { filter } = params
        const { page, perPage } = params.pagination;
        let { field, order } = params.sort;

        const args = buildArgs({
            order: order || "DESC",
            size: perPage,
            pageNumber: page,
            sort: field || "created_at",
        });

        if (filter.dateGte && filter.dateLte) {
            where['created_at'] = {
                _gte: filter.dateGte, _lte: filter.dateLte
            }
        }

        if (filter.delivery_mode) {
            where["delivery_mode"] = {
                _in: filter.delivery_mode
            }
        }

        if (filter.availability_by_service) {
            where['availability_by_service'] = {
                _has_keys_any: filter.availability_by_service
            }
        }

        if (filter.item_name) {
            where['item_label_hk'] = {
                _ilike: `%${filter.item_name}%`
            }
        }

        if (filter.is_available !== undefined) {
            where['is_available'] = {
                _eq: filter.is_available
            };
        }

        if (filter.category) {
            where['item_detail'] = {
                _contains: {
                    item: {
                        category: filter.category
                    }
                }
            };
        }

        const queryResult = await graphqlFetch({
          url: [uriTest, uriDev].includes(window.location.host)
            ? "https://console.gql.m21-ng-core.develop.telinhk.xyz/mobile/v1/graphql"
            : "https://console.gql.m21-ng-core.live.telinhk.xyz/mobile/v1/graphql",
          query: `
                    query allRewardCatalogues($where: reward_catalogues_bool_exp
          $limit: Int
          $offset: Int
          $orderBy: [reward_catalogues_order_by!]){
  reward_catalogues(where: $where
                      limit: $limit
                      offset: $offset
                      order_by: $orderBy){
    id
		created_at
		updated_at
        reward_codes{
            code
            status
        }
		item_detail
		item_label
		redemption_amount
		redeem_limits
		delivery_mode
		availability_by_service
		update_history
  }
    reward_catalogues_aggregate(where: $where){
                aggregate{
                  count
                }
              }
}`,
          variables: {
            where,
            limit: perPage,
            offset: (page - 1) * perPage,
            orderBy: [{ [field]: order.toLowerCase() }],
          },
        });

        

        return {
          data: queryResult?.data?.reward_catalogues || [],
          total:
            queryResult?.data?.reward_catalogues_aggregate?.aggregate?.count || 0,
        };
    }
    async create(resource: string, params: CreateParams<any>): Promise<CreateResult<any>> {
        const toBeCreatedData = {
            ...params.data
        }

        const queryResult = await this.client.gql.mutation({
            mutation: gql`
                mutation CreateRewardCatalogues($input: [RewardCataloguesCreateInput!]!) {
                    createRewardCatalogues(input: $input) {
                        id
                        created_at
                        updated_at
                        item_detail
                        item_label
                        redemption_amount
                        redeem_limits
                        delivery_mode
                        availability_by_service
                    }
                }
            `,
            variables: {
                input: toBeCreatedData
            }
        });

        if (queryResult.error) {
            throw new Error("Failed Create Reward");
        }

        return {
            data: queryResult.createRewardCatalogues
        } as CreateResult
    }
    async getOne(resource: string, params: GetOneParams<any>): Promise<GetOneResult<any>> {
        const queryResult = await this.client.gql.query({
            query: gql`
                query GetRewardCataloguesById($id: UUID ) {
                    getRewardCataloguesById(id: $id) {
                        id
                        created_at
                        updated_at
                        item_detail
                        item_label
                        redemption_amount
                        redeem_limits
                        update_history
                        delivery_mode
                        availability_by_service
                        is_available
                    }
                }
            
            `,
            variables: {
                id: params.id,
            },
        });

        return {
            data: queryResult?.getRewardCataloguesById,
        };
    }
    async update(resource: string, params: UpdateParams<any>): Promise<UpdateResult<any>> {
        console.log('params', params);

        const { error, updateRewardCataloguesById } = await this.client.gql.mutation({
            mutation: `
                mutation UpdateRewardCataloguesById(
                    $ids: [UUID!]!
                    $input: RewardCataloguesUpdateInput!
                ) {
                    updateRewardCataloguesById(ids: $ids, input: $input) {
                        id
                        created_at
                        updated_at
                        item_detail
                        item_label
                        redemption_amount
                        redeem_limits
                        delivery_mode
                        availability_by_service
                        redeem_limits
                        is_available
                        author_id
                        update_history
                    }
                }
            `,
            variables: {
                ids: params.id,
                input: params?.data
            }
        })

        if (error) {
            throw new Error("Failed Update Reward");
        }

        return {
            data: updateRewardCataloguesById[0]
        } as UpdateResult;
    }
    async delete(resource: string, params: DeleteParams<any>): Promise<DeleteResult<any>> {
        const queryResult = await this.client.gql.mutation({
            mutation: gql`
                mutation ($ids: [UUID!]!) {
                    deleteRewardCataloguesById(ids: $ids)
                }
            `,
            variables: {
                ids: [`${params.id}`],
            },
        });

        return {
            data: queryResult?.deleteRewardCataloguesById,
        } as DeleteResult;
    }
}